import ATextField from './index.vue';

ATextField.install = app => {
  app.component(ATextField.name, ATextField);
};

export default ATextField;
